import { render, staticRenderFns } from "./Cytology_EachID.vue?vue&type=template&id=0c483a18&scoped=true"
import script from "./Cytology_EachID.vue?vue&type=script&lang=js"
export * from "./Cytology_EachID.vue?vue&type=script&lang=js"
import style0 from "./Cytology_EachID.vue?vue&type=style&index=0&id=0c483a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c483a18",
  null
  
)

export default component.exports